module.exports = __webpack_public_path__ + "static/media/img16.62e5f33f.jpg";